module.exports = __webpack_public_path__ + "img/MarceloBukin2.eb50bc8f.jpeg";